import { isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import Terminal, { TerminalDto } from "./Terminal"

class TerminalService {
    httpClient: HttpClient<Terminal, TerminalDto> = new HttpClient<Terminal, TerminalDto>(Terminal)
    baseUrl = "terminals"

    async listForPaymentAccount(paymentAccountId: string): Promise<Terminal[]> {
        const res = await this.httpClient.get(`/payment-accounts/${paymentAccountId}/terminals`)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res as Terminal[]
    }

    async update(registrationId: string, inUse: boolean): Promise<Terminal> {
        const res = await this.httpClient.post(`/terminals/${registrationId}`, { inUse })

        if (isError(res)) {
            throw new Error(res.message)
        }
        
        return res as Terminal
    }
    
    updateBeacon(registrationId: string, inUse: boolean): void {
        const blob = new Blob([JSON.stringify({ inUse })], {type : "application/json; charset=UTF-8"})
        navigator.sendBeacon(`/api/terminals/${registrationId}`, blob)
    }
    
    async post(paymentAccountId: string, deviceRegistrationCode: string, deviceName: string): Promise<Terminal> {
        const res = await this.httpClient.post(`/payment-accounts/${paymentAccountId}/terminals`, {
            deviceRegistrationCode,
            deviceName
        })

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res as Terminal
    }
    
    async delete(id: string): Promise<Terminal> {
        const res = await this.httpClient.delete(`/terminals/${id}`)

        if (isError(res)) {
            throw new Error(res.message)
        }
        
        return res as Terminal
    }
}

const instance = new TerminalService()
export default instance


// WEBPACK FOOTER //
// ./src/state/terminal/TerminalService.ts